module.exports = __webpack_public_path__ + "static/media/Technocolabs.dfdfd929.jfif";